/**
 * Bounce integrations API client for the theme's forms (club, warranty).
 *
 * The live theme calls production; any other theme (preview, staging theme,
 * `shopify theme dev`) calls staging, which writes to the test Odoo only.
 *
 * These keys are public by design: they ship to every visitor's browser. They
 * only open the rate-limited form routes and identify the caller as
 * "shopify-theme" in the API logs. Rotate them in AWS Secrets Manager
 * (bounce/internal-api/<env> → FORM_API_KEYS.shopify-theme) and here together.
 */
(function () {
  var theme = window.Shopify && window.Shopify.theme;
  var isLive = !!theme && theme.role === 'main';

  var config = isLive
    ? { env: 'production', baseUrl: 'https://api.bouncesports.co', key: 'Y3sWrMDydwUPVctPIm_HgDwrPm0f8v-F' }
    : { env: 'staging', baseUrl: 'https://api-staging.bouncesports.co', key: 'nwgsLWae3mC92HIHPSPSCduw8aA9gpyA' };

  window.BounceApi = {
    env: config.env,
    post: function (path, body) {
      return fetch(config.baseUrl + path, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': config.key
        },
        body: JSON.stringify(body)
      });
    }
  };
})();
